
import * as __star__ from 'object-hash';

const {
default: __default__,
sha1,
keys,
MD5,
keysMD5,
writeToStream
} = __star__;

export {
sha1,
keys,
MD5,
keysMD5,
writeToStream
};
export default __default__;
